import React, { useEffect, useState } from 'react'
import TopCategoryCard from './TopCategoryCard'
import '../../css/Main/TopCategories.css'
import { SpinningCircles } from 'react-loading-icons'
import axios from 'axios';

const TopCategories = () => {
  const [topcategories,setTopcategories] = useState(null);
  useEffect(() => {
    const fetchTopCategories= async () => {
      const API = process.env.REACT_APP_BACKEND_URL;
      try {
        const response= await axios.get(`${API}/topcategories`);
        setTopcategories(response.data)  
      } catch (error) {
        console.log(error)
      }
    }
    fetchTopCategories();
  },[])
  return (
    <div className='top-categories-container'>
        <h1>Kiemelt Kategóriák</h1>
        <div className='top-categories-cards'>
          {topcategories ? (
            topcategories.map((category, index) => (
              <TopCategoryCard category={category} key={index}/>
            ))
          ) : (
            <div>
              <SpinningCircles />
            </div>
          )}
        </div>
    </div>
  )
}

export default TopCategories